export default __webpack_public_path__ + "static/media/6.7e369653.png";